import { ROUTES } from '@/utils/constants';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@phosphor-icons/react';
import { ArtGrid } from '@/components/shared/ArtGrid';

export function LandingHero() {
  return (
    <section className="landing-hero">
      <div className="landing-hero__panel">
        <div className="landing-wide landing-hero__inner">
          <div className="landing-hero__text">
            <h1 className="landing-hero__title">
              Your identity, all in one place.
            </h1>
            <p className="landing-hero__sub">
              Nestra gives every creative a single home for their releases,
              events, merch, and every platform they&apos;re on.
            </p>
            <div className="landing-hero__actions">
              <Link
                to={ROUTES.SIGNUP}
                className="landing-btn landing-btn--coral"
              >
                Get started free <ArrowRightIcon size={15} weight="bold" />
              </Link>
              <Link
                to={ROUTES.EXAMPLE}
                className="landing-btn landing-btn--ghost-dark"
              >
                See an example
              </Link>
            </div>
          </div>
          <div className="landing-hero__visual">
            <ArtGrid />
          </div>
        </div>
      </div>
    </section>
  );
}
